export default "dist/images/block-feature-overlap2.4cab3f2.png";